module.exports = __webpack_public_path__ + "static/media/coding.984b5dc6.png";